import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import API_BASE_URL from "./config";
import "./Login.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailFromState = location.state?.email || "";
  const [formData, setFormData] = useState({
    email: emailFromState,
    otp_code: "",
    new_password: "",
    confirm_password: ""
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.confirm_password) {
      setError("Passwords do not match");
      return;
    }
    if (formData.new_password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    if (!formData.email || !formData.otp_code) {
      setError("Email and OTP are required");
      return;
    }

    setIsLoading(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email.trim().toLowerCase(),
          otp_code: formData.otp_code.trim(),
          new_password: formData.new_password
        })
      });
      const data = await response.json();

      if (response.ok) {
        alert(data.message || "Password reset successfully.");
        navigate("/login", { replace: true, state: { message: "Password reset successfully. You can now log in." } });
      } else {
        setError(data.message || data.error || "Failed to reset password");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="brand-mini">
          <img src={`${process.env.PUBLIC_URL || ''}/assets/wetano-logo.png`} alt="WeTano Solutions" />
          <span>WeTano Solutions</span>
        </div>
        <div className="login-header">
          <h1>Reset password</h1>
          <p>Enter the OTP sent to your email and choose a new password.</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="name@company.com"
              required
              disabled={!!emailFromState}
            />
          </div>
          <div className="form-group">
            <label htmlFor="otp_code">OTP code</label>
            <input
              type="text"
              id="otp_code"
              name="otp_code"
              value={formData.otp_code}
              onChange={handleChange}
              placeholder="6-digit code from email"
              maxLength={6}
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="new_password">New password</label>
            <input
              type="password"
              id="new_password"
              name="new_password"
              value={formData.new_password}
              onChange={handleChange}
              placeholder="At least 6 characters"
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm_password">Confirm password</label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
              placeholder="Re-enter new password"
              required
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Resetting..." : "Reset password"}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <Link to="/login">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
